export enum ContractType {
  Contracting = 'Contracting',
  Production = 'Production',
  Trading = 'Trading',
  Other = 'Other'
}
